(function($, window, document) {
    "use strict";
    $(function() {
        //##Variables
        var $body = $('body'),
            $window = $(window),
            $doc = $(document),
            defaultEasing = [0.4, 0.0, 0.2, 1];

        //End Variables
        
    /*    $('#popup_box').rebox({ selector: 'a' });*/
    //Search for keywords within the user agent string.  When a match is found, add a corresponding class to the html element and return.  (Inspired by http://stackoverflow.com/a/10137912/114558)
        function addUserAgentClass(keywords) {
          for(var i = 0; i < keywords.length; i++) {
            if(navigator.userAgent.indexOf(keywords[i]) != -1) {
              $("html").addClass(keywords[i].toLowerCase());
              return; //Once we find and process a matching keyword, return to prevent less "specific" classes from being added
            }
          }
        }

        addUserAgentClass(["Chrome", "Firefox", "MSIE", "Safari", "Opera", "Mozilla"]); //Browsers listed generally from most-specific to least-specific
        addUserAgentClass(["Android", "iPhone", "iPad", "Linux", "Mac", "Windows"]); //Platforms, also in order of specificity

    });
}(window.jQuery, window, document));
